
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    // Force scroll to top when component mounts or route changes
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    
    // Reset scrollTop on document and body
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Handle all scrollable elements including dialogs and modals
    const timeout = setTimeout(() => {
      // Find and reset all scrollable containers
      const scrollContainers = document.querySelectorAll(
        '.scroll-area, .scrollArea, [role="dialog"], .overflow-auto, .overflow-y-auto, .max-h-\\[90vh\\], [data-radix-scroll-area-viewport]'
      );
      
      scrollContainers.forEach(container => {
        if (container instanceof HTMLElement) {
          container.scrollTop = 0;
        }
      });
      
      // Force mobile scroll reset
      document.body.style.position = 'fixed';
      document.body.style.position = '';
    }, 100);
    
    return () => clearTimeout(timeout);
  }, [pathname, hash, search]);
  
  return null;
}
